import consumerApi from "api/services/consumer-api";
import consumerApiCa from "api/services/consumer-api-ca";
import { User, UserResponse } from "custom-types/User";
import sanitizeUserResponseObject from "utils/sanitizeUserResponseObject";

const putUser = async (user: User, countryCode = "US"): Promise<User> => {
  const api = countryCode === "CA" ? consumerApiCa : consumerApi;

  const { data } = await api.put<UserResponse>(`/api/profile/v1/user`, user);

  return sanitizeUserResponseObject(data);
};

export default putUser;
